import { useState } from 'react';
import { useAuth } from '../lib/AuthContext';
import Icon from '../components/Icon';

export default function AuthScreen() {
  const { signIn, signUp, signInWithGoogle } = useAuth();
  const [mode, setMode] = useState('signin');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [displayName, setDisplayName] = useState('');
  const [error, setError] = useState('');
  const [notice, setNotice] = useState('');
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError('');
    setNotice('');

    if (mode === 'signup' && !displayName.trim()) {
      setError('Pick a name your teammates will recognise.');
      return;
    }
    if (password.length < 6) {
      setError('Password needs to be at least 6 characters.');
      return;
    }

    setBusy(true);
    const { data, error: err } =
      mode === 'signin'
        ? await signIn(email.trim(), password)
        : await signUp(email.trim(), password, displayName.trim());
    setBusy(false);

    if (err) {
      setError(err.message);
      return;
    }
    if (mode === 'signup' && data?.user && !data?.session) {
      setNotice('Check your email to confirm your account, then sign in.');
    }
  };

  const google = async () => {
    setError('');
    setBusy(true);
    const { error: err } = await signInWithGoogle();
    setBusy(false);
    if (err) setError(err.message);
  };

  return (
    <div className="auth">
      <div className="auth__card">
        <div className="auth__brand">
          <span className="auth__badge">
            <Icon name="shuffle" size={22} />
          </span>
          <h1 className="auth__title">TEAM BALANCER</h1>
          <p className="auth__tagline">Fair sides, every week.</p>
        </div>

        <div className="segmented" role="tablist">
          <button
            type="button"
            role="tab"
            aria-selected={mode === 'signin'}
            className={mode === 'signin' ? 'is-on' : ''}
            onClick={() => {
              setMode('signin');
              setError('');
              setNotice('');
            }}
          >
            Sign in
          </button>
          <button
            type="button"
            role="tab"
            aria-selected={mode === 'signup'}
            className={mode === 'signup' ? 'is-on' : ''}
            onClick={() => {
              setMode('signup');
              setError('');
              setNotice('');
            }}
          >
            Create account
          </button>
        </div>

        <form onSubmit={submit} className="stack">
          {mode === 'signup' && (
            <label className="field">
              <span className="field__label">Display name</span>
              <input
                className="input"
                value={displayName}
                onChange={(e) => setDisplayName(e.target.value)}
                placeholder="What your mates call you"
                autoComplete="nickname"
              />
            </label>
          )}

          <label className="field">
            <span className="field__label">Email</span>
            <input
              className="input"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="you@example.com"
              autoComplete="email"
              required
            />
          </label>

          <label className="field">
            <span className="field__label">Password</span>
            <input
              className="input"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="At least 6 characters"
              autoComplete={mode === 'signin' ? 'current-password' : 'new-password'}
              required
            />
          </label>

          {error && <p className="form-error">{error}</p>}
          {notice && <p className="form-notice">{notice}</p>}

          <button type="submit" className="btn btn--primary btn--block" disabled={busy}>
            {busy ? 'Working…' : mode === 'signin' ? 'Sign in' : 'Create account'}
          </button>
        </form>

        <div className="auth__divider"><span>or</span></div>

        <button type="button" className="btn btn--google btn--block" onClick={google} disabled={busy}>
          <Icon name="google" size={18} />
          Continue with Google
        </button>
      </div>
    </div>
  );
}
